import {Button, Card, Form} from "react-bootstrap";
import React, {useState} from "react";
import { useForm } from "react-hook-form";
import { useNavigate} from "react-router-dom";
import axios from "axios";



export default function Change(){
    const { register, handleSubmit } = useForm();
    const [error, setError] = useState('');
    const navigate = useNavigate();

    function submit(e) {
        if(e.password.length < 6){
            setError("Password must be atleast 6 characters long!");
        }else if(e.password.search(/(?=.*[0-9])/)){
            setError("Password must contain atleast one number");
        }else if(e.password !== e.passwordRepeat){
            setError("Passwords are not the same!");
        }else{
            let bodyFormData = new FormData();
            bodyFormData.append("password", e.password);

            axios.post("/auth/credentials", bodyFormData,{headers: {'content-type': 'application/x-www-form-urlencoded'}})
                .then(response => {
                    console.log(response);
                    if(response.status === 200){
                        if(localStorage.getItem("role")=== "TEACHER"){
                            navigate("/");
                        }else{
                            navigate("/student/"+localStorage.getItem("id"));
                        }
                    }
                })
                .catch(err => {
                    setError(err.response.data.message);
                });
        }



    }

        return (
            <>

                    <Card.Title>Change password</Card.Title>
                    <Form onSubmit={handleSubmit(submit)}>
                        <label style={{color: "red"}}>{error}</label>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>New passport:</Form.Label>
                            <Form.Control {...register("password")} type="password" placeholder="Enter Password" />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Repeat Password</Form.Label>
                            <Form.Control {...register("passwordRepeat")} type="password" placeholder="Enter Password again" />
                        </Form.Group>
                        <Button variant="primary" style={{width: '100%'}} type="submit">
                            Change
                        </Button>
                    </Form>

            </>
        )

}
